const digitsOnly = (value: string) => value.replace(/\D/g, "");

export const isParaguayCountry = (country?: string) => {
  const normalized = (country || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();

  return ["paraguai", "paraguay", "py"].includes(normalized);
};

export const formatStorePhone = (value: string) => {
  const digits = digitsOnly(value);
  if (!digits) return "";

  if (digits.startsWith("595")) {
    return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(
      6,
      9,
    )}-${digits.slice(9)}`;
  }

  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
};

export const getWhatsAppUrl = (value: string) => {
  const digits = digitsOnly(value);
  const phone = digits.startsWith("595") ? digits : `55${digits}`;

  return `https://api.whatsapp.com/send?phone=${phone}`;
};
